import InputDialog from ".";

function InputDeleteDialog(props: {
  dialogCallback: (() => Promise<void> | void) | null;
  onClose: () => void;
}) {
  return (
    <InputDialog
      title="Șterge"
      continue_label="Șterge"
      abort_label="Anulează"
      dialogCallback={props.dialogCallback}
      onClose={props.onClose}
    >
      Ești sigur că vrei să faci asta? Operațiunea este ireversibilă!
    </InputDialog>
  );
}

export default InputDeleteDialog;
